import React, { useEffect, useState } from "react";
import { addMember } from "../ApiMember";
import { LoadingSpinner, isUrdu } from "../../../constants/const";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { GetLanguageString } from "../../helper/Components";
import swal from "sweetalert";
import Select from "react-select";
import { GetSelectedLanguage } from "../../helper/Method";
import { useTranslation } from "react-i18next";
import Draggable from "react-draggable";
import imageCompression from "browser-image-compression";

const EditDocument = ({
  setEditDocumentModal,
  memberId,
  documentId,
  setRefreshList,
  refreshList,
  documentName,
}) => {
  const toggle = () => setEditDocumentModal(false);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [pledgesDropdown, setPledgesDropdown] = useState([]);
  const [errorFile, setErrorFile] = useState();
  const [file, setFile] = useState("");
  const [editDocumentValues, setEditDocumentValues] = useState({
    file: "",
    description: "",
    memberId: memberId,
    pledge: null,
  });
  const [documentTypeId, setDocumentTypeId] = useState(-1);
  const [errors, setErrors] = useState();
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    addMember()
      .EditDocument(documentId)
      .then((res) => {
        setEditDocumentValues(res.data);
        setDocumentTypeId(res.data.staticDocumentType);
        setLoading(false);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
        console.log(err.response?.data || err);
      });
  }, [memberId, documentId]);

  useEffect(() => {
    if (documentTypeId >= 0 && !documentName.includes("Kawaif")) {
      addMember()
        .GetAddPledgesDropdowns(memberId, documentTypeId)
        .then((res) => {
          setPledgesDropdown(res.data);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response?.data || err);
        });
    }
  }, [memberId, documentTypeId, documentName]);

  const handleUpload = async (e) => {
    try {
      const selectedFile = e.target.files[0];

      if (selectedFile && selectedFile.size < 10 * 1024 * 1024) {
        const options = {
          maxSizeMB: 10,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        let compressedFile;
        if (!selectedFile.type.includes("pdf")) {
          compressedFile = await imageCompression(selectedFile, options);
        }

        setFile(compressedFile !== undefined ? compressedFile : selectedFile);
        setErrorFile("");
        setErrors({
          ...errors,
          file: "",
        });
      } else {
        setFile(null);
        setErrorFile(
          selectedFile?.size > 10 * 1024 * 1024 ? (
            <GetLanguageString props="member_add_file_upload_size_error" />
          ) : (
            <GetLanguageString props="member_add_file_upload_error" />
          )
        );
      }
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };

  const validate = () => {
    let temp = {};
    temp.pledge =
      editDocumentValues.pledge === "" ? (
        <GetLanguageString props="member_member_detail_select_pledges_type_error" />
      ) : (
        ""
      );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleChangePledge = (record) => {
    setEditDocumentValues({
      ...editDocumentValues,
      pledge: record,
    });
    setErrors({
      ...errors,
      pledge: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditDocumentValues({
      ...editDocumentValues,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const files = new FormData();
    files.append("File", file);
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      const formData = new FormData();
      formData.append("InputFile", file);  // must match C# property name
      
      formData.append("MemberId", editDocumentValues.memberId);
      formData.append("Description", editDocumentValues.description);
      formData.append("DocumentType.Value", editDocumentValues.documentType ? editDocumentValues.documentType?.value : 0); 
      formData.append("Pledge.Value", editDocumentValues.pledge?.value);
       addMember()
            .EditDocumentSave(documentId, formData)
            .then((res) => {
              swal({
                title: t("member_edit_file"),
                icon: "success",
                className: GetSelectedLanguage() === "en" ? "" : "ur",
                buttons: "OK",
              });
              setLoading(false);
              setButtonDisable(false);
              setRefreshList((prevRefreshList) => !prevRefreshList);
              toggle();
            })
            .catch((err) => {
              console.log(err);
              swal({
                title: err,
                icon: "error",
                buttons: "OK",
              });
              setLoading(false);
              setButtonDisable(false);
            });
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="member_member_detail_documents_edit" />}
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <FormGroup>
                  <Label className="col-form-label">
                    {
                      <GetLanguageString props="member_member_detail_upload_documents" />
                    }
                  </Label>
                  <Input
                    type="file"
                    accept={
                      documentName.includes("Kawaif")
                        ? "image/*,application/pdf"
                        : "image/*"
                    }
                    name="baitFormFront"
                    maxSize={10 * 1024 * 1024}
                    onChange={handleUpload}
                  />
                  {errorFile && <div className="text-error">{errorFile}</div>}
                </FormGroup>
                {documentName !== "Kawaif Form" ? (
                  <FormGroup>
                    <Label className="col-form-label">
                      {" "}
                      {
                        <GetLanguageString props="member_member_detail_select_pledges_type" />
                      }
                    </Label>
                    <Select
                      value={editDocumentValues.pledge}
                      options={pledgesDropdown}
                      className="basic-multi-select ur no-drag"
                      classNamePrefix="select"
                      onChange={(record) => {
                        handleChangePledge(record);
                      }}
                    />
                    {errors?.pledge && (
                      <div className="text-error">{errors.pledge}</div>
                    )}
                  </FormGroup>
                ) : null}
                <FormGroup>
                  <Label>
                    {<GetLanguageString props="common_description" />}
                  </Label>
                  <Input
                    type="text"
                    name="description"
                    className={
                      isUrdu(editDocumentValues.description)
                        ? "ur no-drag"
                        : "no-drag"
                    }
                    value={editDocumentValues.description}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" disabled={buttonDisable} type="submit">
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default EditDocument;
